export enum EnumStatus {
  AKTIF = 'AKTIF',
  NONAKTIF = 'NONAKTIF'
}

export enum EnumStatusV2 {
  AKTIF = 'Aktif',
  NONAKTIF = 'Non-Aktif'
}

export enum EnumOfferMethodType {
  AUTO_ASSIGN = 'AUTO ASSIGN',
  OFFER = 'OFFER'
}

export enum EnumCourierType {
  MARKETPLACE = 'courierMP',
  CUSTOMER = 'courierCA',
  CLIENT = 'courierClient'
}

export enum EnumDedicatedType {
  MARKETPLACE = 'dedicatedMP',
  CUSTOMER = 'dedicatedCA',
  CLIENT = 'dedicatedClient'
}

export enum EnumCourierTypeParams {
  POS = 'POS',
  KVP = 'KVP',
  INTERNAL = 'INTERNAL'
}

export const ManageCourierDedicatedStatus = {
  ...EnumStatus,
}

export enum EnumErrorMessage {
  AREA_NAME_EXIST = 'Area Have been Used'
}

export interface IStyle {
  minWidth: string
  maxWidth: string
}

export interface IDataCell {
  value: number | string | boolean | string[]
  customStyle: IStyle
}

export interface IHeaderCell {
  title: number | string
  customStyle: IStyle
}

export interface IOptions {
  label: string
  value: string | number | boolean | undefined
}

export interface IOptionsCreate {
  open: boolean
  assignee: string
  value: IOptions | undefined
  specialHandling: boolean
}

export interface IOptionsV2 {
  label: string
  assignee: string
  value: string | number | boolean | undefined
  specialHandling: boolean
}

export interface IParams {
  page: number
  per_page: number
  sort: IOptions
  offer: IOptions
  status: IOptions
  keyword: string
}

export interface ICourierDedicatedParams {
  page: number
  per_page: number
  sort: IOptions
  keyword: string
}

export interface ICourierParams {
  page: number
  perPage: number
  q: string
  sortBy: string
  driverType: string
  courierStatus: string
}

export interface IPOSParams {
  page: number
  perPage: number
  search: string
  filterStatus: string
}

export interface IGeoAddressParams {
  search: string
}

export interface IForm {
  areaName: string
  location: Array<number>
  courierMP: Array<IOptions>
  courierCA: Array<IOptions>
  courierClient: Array<IOptions>
  courierCorporateMobil: Array<IOptions>
  courierCorporateMotor: Array<IOptions>
  offerMethod: IOptions
  status: IOptions
}

export interface IFormV2 {
  areaName: string
  location: Array<number>
  dedicatedMp: Array<IOptions>
  dedicatedCa: Array<IOptions>
  dedicatedCorporate: Array<IOptions>
  dedicatedCorporateMobil: Array<IOptions>
  dedicatedCorporateMotor: Array<IOptions>
  offerMethod: IOptions
  status: IOptions
}

export interface IFormDetail extends Omit<IForm, 'status' | 'offerMethod'> {
  offerMethod: string
  status: string
  createdAt: string
  updatedAt: string
  createdBy: string
  updatedBy: string
}

export interface IFormDetailV2 extends Omit<IFormV2, 'status' | 'offerMethod'> {
  offerMethod: string
  status: string
  createdAt: string
  updatedAt: string
  createdBy: string
  updatedBy: string
}

export interface IHistoryFields {
  name: string
  formKey: string
}

export interface CreatePayload {
  area_name: string;
  geo_address_id: Array<number>;
  courier_mp: Array<number>;
  courier_ca: Array<number>;
  courier_client: Array<number>;
  offer_type: string;
  is_active: boolean;
}

export interface UpdatePayload extends CreatePayload {
  id: number
}

export interface IUpdate extends IForm {
  dedicatedMP: Array<IUpdateDedicated>;
  dedicatedCA: Array<IUpdateDedicated>;
  dedicatedCorporate: Array<IUpdateDedicated>;
  dedicatedCorporateMobil: Array<IUpdateDedicated>;
  dedicatedCorporateMotor: Array<IUpdateDedicated>;
}

export interface IUpdateDedicated {
  open: boolean;
  assignee: string;
  value: IOptions | undefined;
  specialHandling: boolean;
}

export const offerMethodOptions: Array<IOptions> = [
  { label: 'Semua', value: '' },
  { label: EnumOfferMethodType.AUTO_ASSIGN, value: EnumOfferMethodType.AUTO_ASSIGN },
  { label: EnumOfferMethodType.OFFER, value: EnumOfferMethodType.OFFER },
]

export const statusOptions: Array<IOptions> = [
  { label: 'Semua', value: undefined },
  { label: EnumStatus.AKTIF, value: true },
  { label: EnumStatus.NONAKTIF, value: false },
]

export const listStatusOptions: Array<IOptions> = [
  { label: 'Semua', value: '' },
  { label: EnumStatus.AKTIF, value: 'ACTIVE' },
  { label: EnumStatus.NONAKTIF, value: 'INACTIVE' },
]

export const sortOptions: Array<IOptions> = [
  { label: 'A-Z', value: 'ASC' },
  { label: 'Z-A', value: 'DESC' },
]
